import moment, { unitOfTime } from "moment";

export interface TimeRange {
    duration: number;
    unit: unitOfTime.DurationConstructor | 'ytd' | 'max';
    label: string;
}

export const TIME_RANGES: TimeRange[] = [
    { duration: 1, unit: 'd', label: '1D' },
    { duration: 5, unit: 'd', label: '5D' },
    { duration: 1, unit: 'M', label: '1M' },
    { duration: 3, unit: 'M', label: '3M' },
    { duration: 6, unit: 'M', label: '6M' },
    { duration: 1, unit: 'ytd', label: 'YTD' },
    { duration: 1, unit: 'y', label: '1Y' },
    { duration: 3, unit: 'y', label: '3Y' },
    { duration: 5, unit: 'y', label: '5Y' },
    { duration: 10, unit: 'y', label: '10Y' },
    { duration: 1, unit: 'max', label: 'MAX' },
]

export interface TimeRangeDates {
    start_date: Date;
    end_date: Date;
}

export const getTimeRangeDates = ({ duration, unit }: TimeRange, max?: Date): TimeRangeDates => {
    const end_date = max ? moment(max) : moment();
    const start_date = moment(end_date.toDate());

    if (unit === 'ytd') {
        return {
            start_date: start_date.startOf('year').toDate(),
            end_date: end_date.toDate(),
        }
    }

    if (unit === 'max') {
        return {
            start_date: moment('2008-01-01').toDate(),
            end_date: end_date.toDate(),
        }
    }

    return {
        start_date: start_date.subtract(duration, unit as unitOfTime.DurationConstructor).toDate(),
        end_date: end_date.toDate(),
    }
}